import { NotificationType } from 'api/notifications/types'
import { URLS } from 'constants/urls'

const buildNotificationPath =
  (baseUrl: string, isProfile = false) =>
  (companyId: number) =>
    `${baseUrl}/${companyId}${isProfile ? '/edit' : ''}`

export const NOTIFICATION_PATH_MAP = {
  [NotificationType.ProfilePendingApproval]: buildNotificationPath(
    URLS.PROFILE + URLS.PROFILE_LIST,
    true
  ),
  [NotificationType.LocationsPendingApproval]: buildNotificationPath(
    URLS.LOCATIONS + URLS.LIST_OF_LOCATIONS
  ),
  [NotificationType.CarsPendingApproval]: buildNotificationPath(
    URLS.FLEET + URLS.VEHICLES
  ),
  [NotificationType.PriceListsPendingApproval]: buildNotificationPath(
    URLS.FLEET + URLS.PRICE_LIST
  ),
  [NotificationType.TermsConditionsPendingApproval]: buildNotificationPath(
    URLS.TERMS_AND_CONDITIONS + URLS.RENTAL_INCLUDES
  ),
  [NotificationType.ProfileDocumentPendingApproval]: buildNotificationPath(
    URLS.DOCUMENTS
  ),
}
